exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-card .v-divider[data-v-252b4724]{border-color:#d2d2d2}.v-list-item[data-v-252b4724]{padding:0 26px}.rowWasEdited[data-v-252b4724]{border:2px solid #ab3b7c;padding:2px}", ""]);

// exports
